<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Spettacoli', route: '/backoffice/spettacoli/' }, { label: 'Gestione Area Compagnia Spettacolo', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">GESTIONE AREA COMPAGNIA SPETTACOLO</h1>
</section>

<app-accredito-backoffice *ngIf="!loading" [spettacolo]="spettacolo" [evento]="evento"></app-accredito-backoffice>
<app-loading-backoffice [visible]="loading"></app-loading-backoffice>